"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ikeaSharedLocalizedComponent = require("@ikea-aoa/ikea-shared-localized-component");

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _ikeaSharedServices = require("@ikea-aoa/ikea-shared-services");

var _SeriesGalleryEjs = _interopRequireDefault(require("./SeriesGallery.ejs.js"));

var _UrlUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/UrlUtility"));

var _ikeaComponentSwiper = _interopRequireDefault(require("@ikea-aoa/ikea-component-swiper"));

var _ikeaComponentLoadVpc = _interopRequireDefault(require("@ikea-aoa/ikea-component-load-vpc"));

require("./SeriesGallery.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This component should be used for displaying a gallery of applications inside a [swiper component](#/component/ikea-component-swiper/)
 *
 * @example
 * <ikea-component name="SeriesGallery" data-visible="true"></ikea-component>
 * @example
 * <SeriesGallery visible={true}></SeriesGallery>
 */
var SeriesGallery = /*#__PURE__*/function (_AbstractLocalizedCom) {
  _inherits(SeriesGallery, _AbstractLocalizedCom);

  var _super = _createSuper(SeriesGallery);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function SeriesGallery(element) {
    var _this;

    _classCallCheck(this, SeriesGallery);

    _this = _super.call(this, element);
    _this.applications = [];
    return _this;
  }
  /**
   * Triggered on load.
   *
   * @override
   */


  _createClass(SeriesGallery, [{
    key: "load",
    value: function load() {
      this._loadApplications();
    }
    /**
     * Triggered when props has changed.
     *
     * @override
     * @param {object} newProps New props.
     */

  }, {
    key: "propsHasChanged",
    value: function propsHasChanged(newProps) {
      if (newProps.visible === false) {
        this.reset();
        this.trigger('close');
      } else if (newProps.visible === true) {
        this.trigger('show');
      }
    }
    /**
     * Gets the template.
     *
     * @override
     * @returns {Function} Template parse function.
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return _SeriesGalleryEjs.default;
    }
    /**
     * Resets the gallery.
     */

  }, {
    key: "reset",
    value: function reset() {
      this._resetVpc();

      this._resetSwiper();
    }
    /**
     * Triggered when an application is clicked.
     *
     * @param {Event} event Event object.
     * @param {string} id Application ID.
     */

  }, {
    key: "handleApplicationClick",
    value: function handleApplicationClick(event, id) {
      var _iterator = _createForOfIteratorHelper(this.applications),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var application = _step.value;

          if (application.id === id) {
            this.trigger('applicationClick', {
              event: event,
              application: application
            });
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Loads applications.
     */

  }, {
    key: "_loadApplications",
    value: function _loadApplications() {
      var _this2 = this;

      _ikeaSharedServices.SeriesGalleryServiceFacade.getApplications().then(function (applications) {
        var urlApplications = _UrlUtility.default.getAppInfo().seriesGallery.applications;

        _this2.applications = applications.filter(function (application) {
          return urlApplications.includes(application.id);
        }).map(function (application) {
          return Object.assign({}, application, {
            url: application.url.replace('{vpcCode}', '')
          });
        });

        _this2.render();
      }).catch(function (error) {
        throw error;
      });
    }
    /**
     * Resets the swiper.
     */

  }, {
    key: "_resetSwiper",
    value: function _resetSwiper() {
      var swiper = this.dom.componentManager.findFirst(_ikeaComponentSwiper.default);

      if (swiper) {
        swiper.reset();
      }
    }
    /**
     * Resets the LoadVpc component.
     */

  }, {
    key: "_resetVpc",
    value: function _resetVpc() {
      var loadVpc = this.dom.componentManager.findFirst(_ikeaComponentLoadVpc.default);

      if (loadVpc) {
        loadVpc.clear();
      }
    }
    /**
     * Returns the supported props.
     *
     * @override
     * @summary
     * showVpc: Set to "false" to hide VPC section.
     * visible: Set to "true" to make it visible.
     * redirect: Set to "false" to disable redirect on click.
     * vpcApplicationNames: Comma seperated string with application names e.g. algot,elvarli,bror,vallentuna,vimle,soderhamn,norsborg,kungshamn,gronlid,lidhult,eket,byod,byocc
     * @returns {SupportedProp[]} Supported prop objects.
     */

  }], [{
    key: "supportedProps",
    get: function get() {
      return [new _ikeaSharedComponent.SupportedProp('showVpc', 'boolean', false, null, true), new _ikeaSharedComponent.SupportedProp('visible', 'boolean', false, null, false), new _ikeaSharedComponent.SupportedProp('redirect', 'boolean', false, null, true), new _ikeaSharedComponent.SupportedProp('vpcApplicationNames', 'string', false, null, '')];
    }
    /**
     * Returns an array of supported events.
     *
     * @override
     * @summary
     * vpcStart: Triggered when VPC starts loading.
     * vpcDone: Triggered when VPC has been loaded successfully. First parameter will be the loaded VPC configuration.
     * vpcError: Triggered when an error occured while loading VPC. First parameter will be the error thrown.
     * close: Triggered when the series gallery is closed.
     * show: Triggered when the series gallery is shown.
     * applicationClick: Triggered when an application is clicked.
     * @returns {string[]} Supported event names. Example: ['click'].
     */

  }, {
    key: "supportedEvents",
    get: function get() {
      return ['show', 'close', 'applicationClick', 'vpcStart', 'vpcDone', 'vpcError'];
    }
    /**
     * Returns the component name.
     *
     * @override
     * @returns {string} Component name.
     */

  }, {
    key: "componentName",
    get: function get() {
      return 'SeriesGallery';
    }
  }]);

  return SeriesGallery;
}(_ikeaSharedLocalizedComponent.AbstractLocalizedComponent);

exports.default = SeriesGallery;